import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import { useHistory, useLocation } from "react-router-dom";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import LoaderButton from "../components/LoaderButton";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { formatDateG } from "../libs/utilsLib";
import { formatJpDateFromString, getAnnualFeeStatusName } from "../libs/utilsLib";
import { Auth, API } from "aws-amplify";
import { onError } from "../libs/errorLib";
import "./Admin.css";
import "../admin.css";

const AdminNewMail = ({members, fields, handleFieldChange, isLoading, handleMailSubmit, backFromMail, mailTos})  => {
  const getFormatDate = (t) => {
    const d = new Date(t);
    return formatDateG(d, 'yyyy/MM/dd HH:mm');
  };

  const handleShowStatic = (e) => {
    e.preventDefault();
    var f = document.frm;
    var url = '/Mng_word_replace.html';

    const newwin=window.open(url, 'WIN', 'width=900, height=700, menubar=no, toolbar=no, scrollbars=yes');

    newwin.focus();
    return false;
  };

  const backFromMail0 = (e) => {
    console.log('aaa');
  };
  return (

        <section id="contents">
          <h2>メール送信</h2>
          <div id="create_mail">
            <h3>配信メール内容</h3>
            <Table className="listtbl">
              <tbody>
                <tr>
                  <th>タイトル</th>
                  <td>
                          <Form.Group controlId="subject" className="" size="sm">
                            <Form.Control
                              type="text"
                              value={fields.subject}
                              onChange={handleFieldChange}
                            />
                          </Form.Group>
                  </td>
                </tr>
                <tr>
                  <th>本文</th>
                  <td>
                    <Form.Group controlId="mailBody">
                      <Form.Control
                        as="textarea"
                        value={fields.mailBody}
                        onChange={handleFieldChange}
                      rows={6}
                     />
                   </Form.Group>
          <p>※置き換え文字を使用する場合は、<a href="#" onClick={handleShowStatic}>こちらの一覧</a>に記載されている文字列を使用してください。</p>
                  </td>
                </tr>
              </tbody>
            </Table>
          <div id="send_list">
            <h3>配信先一覧</h3>
            <Table className="listtbl">
              <caption>1 ページ目</caption>
              <tbody>
                <tr>
                  <th>応募者</th>
                  <th>応募者（かな）</th>
                  <th>email</th>
                  <th>入会日</th>
                  <th>更新日</th>
                </tr>
              { mailTos.map((i) => (
                <tr>
                  <td>{members[i].familyName} {members[i].givenName}</td>
                  <td>{members[i].familyNameKana} {members[i].givenNameKana}</td>
                  <td>{members[i].affiliationEmail }</td>
                  <td>{members[i].admissionDate}</td>
                  <td>{getFormatDate(members[i].updatedAt)}</td>
                </tr>
              ))}
              </tbody>
            </Table>
          </div>
            <div className="opBtns">
          <Button id="backToList" active size="lg" active onClick={ backFromMail } >
          戻る
           </Button>
          <LoaderButton
            block
            size="lg"
            type="button"
            variant="success"
            isLoading={isLoading}
            id="confirm"
            onClick={handleMailSubmit}
          >
            次へ
          </LoaderButton>
        </div>
        </div>
      </section>
  );
}

export default AdminNewMail;
